import { makeStyles, createStyles } from '@material-ui/core/styles'

const WhatsNewSearchBarStyles = makeStyles((theme) =>
  createStyles({
    searchBarWrapper: {
      position: 'sticky',
      paddingBottom: 50,
      background: theme.palette.components.newsBackground,
      alignSelf: 'flex-start',
      marginRight: '20px',

      [theme.breakpoints.down('md')]: {
        width: '100%',
        zIndex: 20,
        paddingBottom: 20,
        paddingTop: 20,
        marginRight: '0px',
      },
      [theme.breakpoints.up(769)]: {
        paddingTop: 0,
      },
      [theme.breakpoints.down('xs')]: {
        paddingTop: 12,
      },
    },
    sidePanel: {
      padding: '5px',
    },
    filterBar: {
      marginTop: '10px',
      height: '40px',
      display: 'flex',
      flexDirection: 'row',
    },
    filterBarHeader: {
      background: theme.color.rutgersRed,
      color: theme.color.white,
      width: '55px',
      padding: '10px',
    },
    filterBarContent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    divider: {
      marginTop: '12px',
    },
    sidePanelText: {
      paddingTop: theme.spacing(0.5),
      textAlign: 'center',
    },
  }),
)

export default WhatsNewSearchBarStyles
